<app-breadcrumbs title="Detalle Exportadores" [breadcrumbItems]="[{label:'Dashboard',link:'/'},{label:'Exportadores',active:true}]"></app-breadcrumbs>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header d-flex align-items-center">
                <div class="flex-grow-1">
                    <h5 class="card-title mb-0">
                        <i class="ri-team-line text-primary me-2"></i>Listado de Exportadores / Clientes
                    </h5>
                    <p class="text-muted small mt-1 mb-0">Clasificacion completa de clientes por operaciones</p>
                </div>
                <button class="btn btn-success btn-sm" (click)="descargar()" *ngIf="listaExportadores.length > 0">
                    <i class="ri-download-line me-1"></i>Exportar Excel
                </button>
            </div>
            <div class="card-body">

                <!-- Loading -->
                <div class="text-center py-5" *ngIf="isLoading">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="text-muted mt-2">Cargando datos...</p>
                </div>

                <!-- Empty state -->
                <div class="text-center py-5" *ngIf="!isLoading && listaExportadores.length === 0">
                    <i class="ri-inbox-line" style="font-size:3rem;color:#adb5bd"></i>
                    <p class="text-muted mt-2">No existe suficiente informacion para procesar este grafico.</p>
                </div>

                <!-- Table -->
                <div class="table-responsive" *ngIf="!isLoading && listaExportadores.length > 0">
                    <table class="table table-hover align-middle mb-0">
                        <thead class="table-light">
                        <tr>
                            <th>#</th>
                            <th>RUC</th>
                            <th>Exportador / Cliente</th>
                            <th class="text-center">Total Operaciones</th>
                            <th class="text-center">KPI Promedio</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of listaExportadores; let i = index">
                            <td class="text-muted small">{{i + 1}}</td>
                            <td><span class="badge bg-soft-secondary text-secondary">{{item.cliente_ruc}}</span></td>
                            <td><strong>{{item.cliente_nombrecomercial}}</strong></td>
                            <td class="text-center">
                                <span class="badge bg-soft-primary text-primary fs-13">{{item.totalOperaciones}}</span>
                            </td>
                            <td class="text-center">
                                <span class="badge bg-soft-warning text-warning fs-13">{{item.promedioKPI}}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
